import Axios from "@/models/axios";
import PrintedMaterialConfig from '@/configs/printed-material';

class PrintedMaterialApi extends Axios {
  path() {
    return `papi/PrintedMaterial/${PrintedMaterialConfig.UNIQUE_IDENTIFIER_API_KEY}`;
  }
}

export default PrintedMaterialApi;
